import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
import SimpleDatePicker from '@/shared/components/input/SimpleDatePicker';
import ToastrService from '@/shared/services/ToastrService';
import messages from '../employeeDetailMessages';
const today = () => moment()
    .utc()
    .startOf('day');
const UpdateInternalPriceModal = ({ show, internalPrice, onClose, onConfirm, }) => {
    const intl = useIntl();
    const [updateRegistrations, setUpdateRegistrations] = useState(false);
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (show) {
            setUpdateRegistrations(false);
            setStartDate(today());
            setEndDate(today());
            setSaving(false);
        }
    }, [show]);
    const handleConfirm = async () => {
        if (updateRegistrations && (!startDate || !endDate)) {
            ToastrService.error(intl.formatMessage(messages.StartEndDateRequired));
            return;
        }
        setSaving(true);
        try {
            await onConfirm({
                internalPrice,
                updateRegistrations,
                startDate: (startDate !== null && startDate !== void 0 ? startDate : today()).toISOString(),
                endDate: (endDate !== null && endDate !== void 0 ? endDate : today()).toISOString(),
            });
            onClose();
        }
        finally {
            setSaving(false);
        }
    };
    return (_jsx(OkCancelModal, Object.assign({ show: show, title: intl.formatMessage(messages.RecalculateRegistrations), zendeskArticle: "5434879956242", onClose: onClose, onSave: handleConfirm, okLabel: intl.formatMessage(messages.Confirm), disabled: saving, disableFullScreen: true }, { children: _jsxs("div", Object.assign({ className: "form-horizontal margin10B" }, { children: [_jsx("div", Object.assign({ className: "form-group" }, { children: _jsx("div", Object.assign({ className: "col-sm-8 col-sm-offset-4" }, { children: _jsx(Checkbox, { text: intl.formatMessage(messages.RecalculateRegistrationsWithNewPrice), value: updateRegistrations, onClick: (val) => setUpdateRegistrations(val) }) })) })), _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("label", Object.assign({ className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.RegistrationsFrom) })), _jsx("div", Object.assign({ className: "col-sm-6" }, { children: _jsx(SimpleDatePicker, { id: "internalPriceStartDate", date: startDate, onDateChange: (d) => setStartDate(d), disabled: !updateRegistrations, isOutsideRange: () => false, numberOfMonths: 1, block: true }) }))] })), _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("label", Object.assign({ className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.RegistrationsUntil) })), _jsx("div", Object.assign({ className: "col-sm-6" }, { children: _jsx(SimpleDatePicker, { id: "internalPriceEndDate", date: endDate, onDateChange: (d) => setEndDate(d), disabled: !updateRegistrations, isOutsideRange: () => false, numberOfMonths: 1, block: true }) }))] }))] })) })));
};
export default UpdateInternalPriceModal;
